import graphql__c88839847dbb2c62ac3f from "./__generated__/AppUserDestinationInputTransferMutation.graphql.ts";import { Alert, Button, Input } from '@portal/components'
import { graphql } from 'babel-plugin-relay/macro'
import React, { useState } from 'react'
import { useMutation } from 'react-relay/hooks'
import * as Yup from 'yup'

import { AppUserDestinationInputTransferMutation } from './__generated__/AppUserDestinationInputTransferMutation.graphql'
import TransferAppConfirmationModal from './TransferAppConfirmationModal'

const transferMutation = graphql__c88839847dbb2c62ac3f

const validationSchema = Yup.string().email().required()

type Props = {
  appId: string
}

const AppUserDestinationInput: React.FC<Props> = ({ appId }) => {
  const [transferApp, isTransferringApp] =
    useMutation<AppUserDestinationInputTransferMutation>(transferMutation)
  const [value, setValue] = useState('')
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false)
  const [transferError, setTransferError] = useState<Error>()

  const handleEmailChanged = (evt: React.ChangeEvent<HTMLInputElement>) =>
    setValue(evt.target.value)

  const handleTransferClicked = () => {
    setTransferError(undefined)
    setIsConfirmationOpen(true)
  }

  const handleConfirmationClosed = (confirmTransfer: boolean) => {
    if (confirmTransfer) {
      transferApp({
        variables: { appId, toEmail: value },
        onCompleted: () => {
          setIsConfirmationOpen(false)
        },
        onError: (err) => {
          setTransferError(err)
        },
      })
    } else {
      setIsConfirmationOpen(false)
    }
  }

  const isInvalid = !validationSchema.isValidSync(value)

  return (
    <>
      {!!transferError && (
        <Alert
          autoDismiss={false}
          variant="danger"
        >{`Could not create the app transfer request: ${transferError.message}`}</Alert>
      )}
      <TransferAppConfirmationModal
        isOpen={isConfirmationOpen}
        onClose={handleConfirmationClosed}
        appId={appId}
        destination={value}
        isProcessing={isTransferringApp}
      />

      <div className="max-w-xl">
        <div>
          <Input
            autoComplete="off"
            id="email"
            label="Email address"
            description="The email address of the transfer recipient"
            onChange={handleEmailChanged}
            placeholder="email@address.com"
            value={value}
          />
        </div>
        <Button
          disabled={isInvalid}
          onClick={handleTransferClicked}
          className="mt-8"
          variant="critical"
        >
          Transfer
        </Button>
      </div>
    </>
  )
}

export default AppUserDestinationInput
